import AnimationClip from '../AnimationClip';
import UIImageComponent from '../../../Component/UI/Image';
import Renderable from '../../../Component/Renderable';
import ColorFilter from '../../../Component/ColorFilter';
import { AwaitIterators } from '../AnimationHelper';
import { StarChestHelper } from '../../../Utility/StarChestHelper';
import StarChest from '../../../Prefabs/StarChest/StarChest';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import Game from '../../../Game';
import { STAR_CHEST_TIER_DATA } from '../../../Constants/Chests';

export interface StarChestUpgradeParams {
    tier: number;
    updateTexture?: boolean;
}

const longDuration = 500;
const shortDuration = 250;

export class StarChestUpgrade extends AnimationClip<StarChestUpgradeParams> {
    public *execute(
        gameObject: StarChest,
        meta: StarChestUpgradeParams
    ): IterableIterator<number> {
        // Update the texture if not animated
        const { tier, updateTexture = true } = meta;

        const oldChest = gameObject.findChildByName('star_chest_old');
        const oldChestRenderable = oldChest.getComponent(Renderable);
        const oldChestImage = oldChest.getComponent(UIImageComponent);
        const oldChestAlpha = this.getTween(oldChestRenderable).to(
            { alpha: 0 },
            longDuration
        );
        const oldChestColorFilter = oldChest.getComponent(ColorFilter);
        const oldChestColorTween = this.getTween(oldChestColorFilter).to(
            { brightness: 5 },
            shortDuration
        );

        const newChest = gameObject.findChildByName('star_chest_new');
        const newChestRenderable = newChest.getComponent(Renderable);
        const newChestImage = newChest.getComponent(UIImageComponent);
        const newChestAlpha = this.getTween(newChestRenderable).to(
            { alpha: 1 },
            longDuration
        );

        const shine = gameObject.find('star_chest_shiny');
        const shineRenderable = shine.getComponent(Renderable);
        const shineAlphaTween = this.getTween(shineRenderable).to(
            { alpha: 1 },
            shortDuration
        );

        newChestRenderable.alpha = 0;
        if (updateTexture) {
            newChestImage.texture = StarChestHelper.getStarChestTexture(tier);
        }

        oldChestRenderable.alpha = 1;

        // 1/4 of total duration
        yield* AwaitIterators([
            this.startTween(shineAlphaTween),
            this.startTween(oldChestColorTween),
        ]);

        PlaySound(STAR_CHEST_TIER_DATA[tier].specialUpgradeSfx ? 'chest-upgrade-2' : 'chest-upgrade-1');

        // 1/2 of duration
        yield* AwaitIterators([
            this.startTween(oldChestAlpha),
            this.startTween(newChestAlpha),
        ]);

        shineAlphaTween.to({ alpha: 0 }, shortDuration);

        // 1/4 of duration
        yield* this.startTween(shineAlphaTween);

        if (updateTexture) {
            oldChestImage.texture = StarChestHelper.getStarChestTexture(tier);
        }
        oldChestColorFilter.brightness = 1;
        oldChestRenderable.alpha = 1;
    }
}
